import React, { useMemo, useCallback, useState } from "react";
import * as ReactDOMClient from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from "@mui/material";
//import AuthContext from "../../context/authProvider";
import useAuth from "../../hooks/useAuth";

const Marker = (options) => {
  const { auth } = useAuth();
  const authRef = React.useRef(auth);
  React.useEffect(() => {
    authRef.current = auth;
  }, [auth]);
  const miniTrackingInfoBoxSetting = useCallback(() => {
    if (authRef.current && authRef.current.userProfile && authRef.current.userProfile.hasOwnProperty("web_settings") && authRef.current.userProfile["web_settings"].hasOwnProperty("miniTrackingBox")) {
      //console.log("has setting : miniTrackingInfoBoxSetting memo", Boolean(auth.userProfile.web_settings["miniTrackingBox"] == "true"));
      return Boolean(authRef.current.userProfile.web_settings["miniTrackingBox"] === "true");
    } return false;
  }, []);
   
  const marker = React.useMemo(() => {
    let infowindow = new window.google.maps.InfoWindow({
      content: '<div id="infoWindow' + options.id + '" />',
      disableAutoPan: options.fitter ? true : false,
    });
    console.log("Marker construct popup miniTrackingEnabled", options.popup, miniTrackingInfoBoxSetting());
    const m = new window.google.maps.Marker();
    m._properties = { popup: infowindow, root: null };
    return m;
  }, [options]);
  
  const renderInfoWindow = useCallback(() => {
    if (marker && marker._properties?.root && !options.streetView) {
      console.log("renderInfoWindow miniTrackingEnabled,liveView,streetView,authRef.current ", miniTrackingInfoBoxSetting(), options.liveView, options.streetView, authRef.current);
      if (miniTrackingInfoBoxSetting() === true && options.liveView===false) {
        //console.log("renderInfoWindow: minibox", miniTrackingInfoBoxSetting(), options.liveView);
        marker._properties.root.render(
          <InfoWindowMiniBox
            infoContent={options.infoContent}
            count={options.count}
            fitter={options.fitter}
            totalMarkers={options.totalMarkers}
            //onMarkerStreetViewClick={options.onMarkerStreetViewClick}
            //onImageView={options.onImageView}
            streetViewMode={options.streetView}
          />
        );
      } else {
        marker._properties.root.render(
          <InfoWindow
            infoContent={options.infoContent}
            count={options.count}
            fitter={options.fitter}
            totalMarkers={options.totalMarkers}
            onMarkerStreetViewClick={options.onMarkerStreetViewClick}
            onImageView={options.onImageView}
            streetViewMode={options.streetView}
          />
        );
      }
    }
  }, [marker, options.infoContent, options.streetView, options.liveView,auth]); //
  // const renderInfoWindowMiniBox = useCallback(() => {
  //   if (marker && marker.properties.root && !options.streetView) {
  //     marker.properties.root.render(
  //       <InfoWindowMiniBox          
  //         infoContent={options.infoContent}
  //         count={options.count}
  //         fitter={options.fitter}
  //         totalMarkers={options.totalMarkers}
  //         //onMarkerStreetViewClick={options.onMarkerStreetViewClick}
  //         //onImageView={options.onImageView}
  //         streetViewMode={options.streetView}
  //       />
  //     );
  //   }
  // }, [marker, options.infoContent, options.streetView]);
  
  // React.useEffect(() => {
  //   console.log("marker ,web_settings,miniTrackingInfoBoxSetting", auth.userProfile.web_settings, miniTrackingInfoBoxSetting());
  //   renderInfoWindow();
  // }, [miniTrackingInfoBoxSetting]);
  React.useEffect(() => {
    console.log("marker changed miniBoxEnabled liveView streetView", miniTrackingInfoBoxSetting(),options.liveView, options.streetView);
    // remove marker from map on unmount
    return () => {
      if (marker) {
        console.log("marker changed deconstruct");
        marker._properties?.popup?.close();
        marker._properties?.popup?.setMap(null);
        if (window.google) {
          window.google.maps.event.clearListeners(marker, "click");
          if (marker._properties?.popup) {
            window.google.maps.event.clearListeners(marker._properties.popup, "domready");
          }
          marker.setMap(null);
        }
      }
    };
  }, [marker]);

  React.useEffect(() => {
    console.log("options.infoContent liveView changed", options.infoContent, options.liveView);
    renderInfoWindow();
  }, [options.infoContent, options.liveView]);

  React.useEffect(() => {
    if (marker && options) {
      console.log("marker, options (miniboxenabled,popup,displayPath,streetView) changed: ", miniTrackingInfoBoxSetting(), options.popup, options.displayPath,options.streetView, marker);
      if (options.streetView) {
        // marker.properties.popup.close();
        // marker.properties.popup.setMap(null);
        marker.setMap(null);
      } else {
        marker.setOptions(options);
        if (window.google) {
          window.google.maps.event.clearListeners(marker, "click");
          if (marker._properties?.popup) {
            window.google.maps.event.clearListeners(marker._properties.popup, "domready");
          }
        }
        // console.log("getMap", marker._properties.popup.getMap() ? true : false);
        marker.addListener("click", function () {
          if (options.map && !options.drawingMode) {
            if (this._properties?.popup) {
              this._properties.popup.open(options.map, this);
            }
          }
        });

        marker._properties?.popup?.addListener("domready", function (e) {
          if (!marker._properties.root) {
            marker._properties.root = ReactDOMClient.createRoot(document.getElementById("infoWindow" + options.id));
          }
          renderInfoWindow();
        });
        if (options.map && marker) {
          if (options.drawingMode) {
            marker._properties?.popup?.close();
            marker._properties?.popup?.setMap(null);
          } else if (miniTrackingInfoBoxSetting() === true && options.liveView === false) {
            //show marker minibox
            console.log("marker,auth change (force open) miniTrackingInfoBoxSetting,options.liveView", miniTrackingInfoBoxSetting, options.liveView);
            marker._properties?.popup?.open(options.map, marker);
          } else {
            if (!options.displayPath) {
              if (options.popup) {
                marker._properties?.popup?.open(options.map, marker);
              } else {
                // if (options.userRight === "V") {
                marker._properties?.popup?.close();
                marker._properties?.popup?.setMap(null); // setmap(null)
                // }
              }
            }
          }
        }
      }
    }
  }, [marker, options]);

  React.useEffect(() => {
    if (marker && options) {
      console.log("marker changed options.displayPath,options.popup", options.displayPath, options.popup);
      if ((miniTrackingInfoBoxSetting() === false && options.liveView === false) && options.fitter == false) {
        marker._properties?.popup?.close();
        marker._properties?.popup?.setMap(null);
        console.log("marker changed close popup options.displayPath");
      }
    }
  }, [options.displayPath]);
  React.useEffect(() => {
    console.log("render marker liveView miniBoxEnabled streetView", options.liveView, miniTrackingInfoBoxSetting(), options.streetView);
  });
  return null;
};
/** Convert a bearing in degrees to an 8-point cardinal label */
const toCardinal = (deg) => {
  if (deg == null) return "";
  const dirs = ["N","NE","E","SE","S","SW","W","NW"];
  return dirs[Math.round(((deg % 360) + 360) % 360 / 45) % 8];
};

const InfoWindowMiniBox = ({ infoContent }) => {
  const ignColor = infoContent.invalidDate ? "#888" : infoContent.ignitionOn ? "#18ba2b" : "#e53935";
  const ignLabel = infoContent.invalidDate ? "Stale" : infoContent.ignitionOn ? "On" : "Off";
  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", minWidth: 160 }}>
      {/* Header */}
      <div style={{ background: "#1a1a1a", padding: "7px 10px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
        <span style={{ color: "#fff", fontWeight: 700, fontSize: 13, letterSpacing: "0.3px" }}>{infoContent.reg}</span>
        <span style={{ background: ignColor, color: "#fff", fontSize: 9, fontWeight: 600, padding: "2px 6px", borderRadius: 8, letterSpacing: "0.3px" }}>{ignLabel}</span>
      </div>
      {/* Body */}
      <div style={{ padding: "7px 10px", background: "#fff" }}>
        {infoContent.fleetNum && infoContent.fleetNum !== "" && (
          <div style={{ fontSize: 11, color: "#555", marginBottom: 4 }}>{infoContent.fleetNum}</div>
        )}
        {!infoContent.invalidDate && (infoContent.speed || infoContent.heading) && (
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 2 }}>
            {infoContent.speed && (
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <FontAwesomeIcon icon="gauge-high" style={{ fontSize: 10, color: "#00bcd4" }} />
                <span style={{ fontSize: 12, fontWeight: 600, color: "#222" }}>{infoContent.speed} <span style={{ fontWeight: 400, color: "#888", fontSize: 10 }}>km/h</span></span>
              </div>
            )}
            {infoContent.heading != null && (
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <FontAwesomeIcon icon="arrow-up" style={{ fontSize: 10, color: "#00bcd4", transform: `rotate(${infoContent.heading}deg)`, display: "inline-block" }} />
                <span style={{ fontSize: 12, fontWeight: 600, color: "#222" }}>{Math.round(infoContent.heading)}°</span>
                <span style={{ fontSize: 10, color: "#888" }}>{toCardinal(infoContent.heading)}</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}; //InfoWindowMiniBox
// ── Shared style constants ────────────────────────────────────────────────────
const IW = {
  font:    "'Segoe UI', system-ui, -apple-system, sans-serif",
  dark:    "#1a1a1a",
  green:   "#18ba2b",
  red:     "#e53935",
  grey:    "#888",
  cyan:    "#00bcd4",
  muted:   "#6b7280",
  border:  "#f0f0f0",
};

// Icon + text row
const IWRow = ({ icon, iconColor, text, bold }) =>
  text ? (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 7, marginBottom: 5 }}>
      <FontAwesomeIcon icon={icon} style={{ color: iconColor || IW.muted, fontSize: 11, marginTop: 2, flexShrink: 0 }} />
      <span style={{ fontSize: 12, color: bold ? "#111" : "#444", fontWeight: bold ? 600 : 400, lineHeight: 1.4 }}>{text}</span>
    </div>
  ) : null;

const InfoWindow = ({
  infoContent,
  onMarkerStreetViewClick,
  onImageView,
  count,
  fitter,
  totalMarkers,
  streetViewMode,
}) => {
  // Hook must be at top level — before any early return
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    const text = infoContent.address
      ? `${infoContent.address}\n${infoContent.lat}, ${infoContent.lng}`
      : `${infoContent.lat}, ${infoContent.lng}`;
    navigator.clipboard?.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  // ── Trip waypoint popup ───────────────────────────────────────────────────
  if (infoContent.displayTrip) {
    const isStart  = infoContent.type === "start";
    const isEnd    = infoContent.type === "end";
    const typeColor = isStart ? "#0696d7" : isEnd ? "#ea4747" : IW.green;
    const typeLabel = isStart ? "Trip Start" : isEnd ? "Trip End" : "En Route";
    const typeIcon  = isStart ? "circle-play" : isEnd ? "circle-stop" : "circle-chevron-up";

    return (
      <div style={{ fontFamily: IW.font, minWidth: 220, maxWidth: 270, fontSize: 13 }}>
        {/* Header */}
        <div style={{ background: IW.dark, padding: "9px 12px", display: "flex", alignItems: "center", gap: 8 }}>
          <FontAwesomeIcon
            icon={typeIcon}
            style={{ color: typeColor, fontSize: 14, transform: (!isStart && !isEnd) ? `rotate(${infoContent.heading || 0}deg)` : "none", display: "inline-block" }}
          />
          <span style={{ color: "#fff", fontWeight: 700, fontSize: 13 }}>{typeLabel}</span>
          {infoContent.speed && (
            <span style={{ marginLeft: "auto", background: "rgba(255,255,255,0.12)", color: "#fff", fontSize: 11, padding: "2px 7px", borderRadius: 8 }}>
              {infoContent.speed} km/h
            </span>
          )}
        </div>

        {/* Body */}
        <div style={{ padding: "10px 12px", background: "#fff" }}>
          {infoContent.carMakeModel && (
            <div style={{ fontWeight: 700, fontSize: 13, color: "#111", marginBottom: 8 }}>{infoContent.carMakeModel}</div>
          )}
          <IWRow icon="location-dot"  iconColor={IW.cyan}  text={infoContent.location} />
          <IWRow icon="clock"         iconColor={IW.muted} text={infoContent.dateTime} />
          {infoContent.heading != null && (
            <IWRow icon="arrow-up"
              iconColor={IW.cyan}
              text={`${Math.round(infoContent.heading)}°  ${toCardinal(infoContent.heading)}`}
            />
          )}
        </div>

        {/* Footer: coords + action buttons */}
        <div style={{ borderTop: `1px solid ${IW.border}`, padding: "8px 12px", background: "#f9f9f9" }}>
          {(infoContent.lat || infoContent.lng) && (
            <div style={{ fontSize: 10, color: IW.muted, marginBottom: 6, fontFamily: "monospace" }}>
              {infoContent.lat}, {infoContent.lng}
            </div>
          )}
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            {!streetViewMode && (
              <div className="tooltip">
                <IconButton
                  aria-label="street view"
                  size="small"
                  onClick={() => onMarkerStreetViewClick({ lat: infoContent.lat, lng: infoContent.lng }, infoContent.heading)}
                  style={{ padding: 5 }}
                >
                  <span className="tooltiptext">Street View</span>
                  <FontAwesomeIcon icon="street-view" style={{ color: "#d2b919", fontSize: 14 }} />
                </IconButton>
              </div>
            )}
            {infoContent.camFile && !streetViewMode && (
              <div className="tooltip">
                <IconButton
                  aria-label="camera file"
                  size="small"
                  onClick={() => onImageView({
                    fileData: infoContent.camFile,
                    markerData: { carMakeModel: infoContent.carMakeModel, speed: infoContent.speed, heading: infoContent.heading, location: infoContent.location },
                  })}
                  style={{ padding: 5 }}
                >
                  <span className="tooltiptext">{infoContent.camFile[0].filePath || infoContent.camFile[0].pathtofile || "Camera file"}</span>
                  <FontAwesomeIcon icon="file-image" style={{ color: IW.cyan, fontSize: 14 }} />
                </IconButton>
              </div>
            )}
            {totalMarkers > 1 && (
              <span style={{ marginLeft: "auto", fontSize: 10, color: IW.muted, fontWeight: 600 }}>
                {count}/{totalMarkers}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }

  // ── Live vehicle popup ────────────────────────────────────────────────────
  const ignColor = infoContent.invalidDate ? IW.grey : infoContent.ignitionOn ? IW.green : IW.red;
  const ignLabel = infoContent.invalidDate ? "Stale" : infoContent.ignitionOn ? "Ignition On" : "Parked";

  return (
    <div style={{ fontFamily: IW.font, minWidth: 230, maxWidth: 280, fontSize: 13 }}>
      {/* Header — extra right padding leaves room for the Google Maps close (×) button */}
      <div style={{ background: IW.dark, padding: "9px 30px 9px 12px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
        <div>
          <div style={{ color: "#fff", fontWeight: 700, fontSize: 14, letterSpacing: "0.3px" }}>{infoContent.reg}</div>
          {infoContent.fleetNum && <div style={{ color: "rgba(255,255,255,0.5)", fontSize: 10, marginTop: 1 }}>{infoContent.fleetNum}</div>}
        </div>
        <span style={{ background: ignColor, color: "#fff", fontSize: 9, fontWeight: 700, padding: "3px 8px", borderRadius: 10, letterSpacing: "0.4px", whiteSpace: "nowrap" }}>
          {ignLabel}
        </span>
      </div>

      {/* Speed + heading highlight bar */}
      {!infoContent.invalidDate && (infoContent.speed || infoContent.heading != null) && (
        <div style={{ background: "#f0fafe", borderBottom: `1px solid ${IW.border}`, padding: "7px 12px", display: "flex", alignItems: "center", gap: 16 }}>
          {infoContent.speed && (
            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
              <FontAwesomeIcon icon="gauge-high" style={{ color: IW.cyan, fontSize: 12 }} />
              <span style={{ fontWeight: 700, fontSize: 13, color: "#111" }}>{infoContent.speed}</span>
              <span style={{ fontSize: 10, color: IW.muted }}>km/h</span>
            </div>
          )}
          {infoContent.heading != null && (
            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
              <FontAwesomeIcon icon="arrow-up" style={{ color: IW.cyan, fontSize: 12, transform: `rotate(${infoContent.heading}deg)`, display: "inline-block" }} />
              <span style={{ fontWeight: 700, fontSize: 13, color: "#111" }}>{Math.round(infoContent.heading)}°</span>
              <span style={{ fontSize: 11, color: IW.muted }}>{toCardinal(infoContent.heading)}</span>
            </div>
          )}
        </div>
      )}

      {/* Body */}
      <div style={{ padding: "10px 12px", background: "#fff" }}>
        {/* Fitter / technician */}
        {fitter && infoContent.userName && (
          <>
            <IWRow icon="user-tie" iconColor={IW.cyan} text={infoContent.userName} bold />
            <div style={{ borderTop: `1px solid ${IW.border}`, margin: "6px 0" }} />
          </>
        )}

        {/* Vehicle details */}
        {(infoContent.carMakeModel || infoContent.color) && (
          <IWRow icon="car" iconColor={IW.muted}
            text={[infoContent.carMakeModel, infoContent.color].filter(Boolean).join(" · ")}
          />
        )}

        {/* Phone numbers */}
        {infoContent.cellphone1 && (
          <IWRow icon="phone" iconColor={IW.muted} text={infoContent.cellphone1} />
        )}
        {infoContent.cellphone2 && infoContent.cellphone2 !== infoContent.cellphone1 && (
          <IWRow icon="phone" iconColor={IW.muted} text={infoContent.cellphone2} />
        )}

        {/* V-user account / status / service */}
        {infoContent.clientAcc && (
          <IWRow icon="file-invoice" iconColor={IW.muted} text={`Acc: ${infoContent.clientAcc}`} />
        )}
        {infoContent.ops && (
          <IWRow icon="circle-info" iconColor={IW.muted} text={`Status: ${infoContent.ops}`} />
        )}
        {(infoContent.serviceLevel || infoContent.serviceType) && (
          <IWRow icon="layer-group" iconColor={IW.muted}
            text={`Service: ${[infoContent.serviceLevel, infoContent.serviceType].filter(Boolean).join(" - ")}`}
          />
        )}

        {/* Address */}
        {infoContent.address && (
          <IWRow icon="location-dot" iconColor={IW.cyan} text={infoContent.address} />
        )}

        {/* Timestamp */}
        {infoContent.updateDate && (
          <IWRow
            icon="clock"
            iconColor={infoContent.invalidDate ? IW.red : IW.muted}
            text={infoContent.updateDate.toLocaleString("en-GB")}
            bold={infoContent.invalidDate}
          />
        )}
      </div>

      {/* Footer: copy coordinates */}
      {(infoContent.lat || infoContent.address) && (
        <div style={{ borderTop: `1px solid ${IW.border}`, padding: "6px 12px", background: "#f9f9f9", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span style={{ fontSize: 10, color: IW.muted, fontFamily: "monospace" }}>
            {infoContent.lat != null ? `${infoContent.lat}, ${infoContent.lng}` : ""}
          </span>
          <IconButton size="small" onClick={handleCopy} style={{ padding: 4 }} title="Copy location">
            <FontAwesomeIcon
              icon={copied ? "circle-check" : "copy"}
              style={{ fontSize: 12, color: copied ? IW.green : IW.muted }}
            />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default React.memo(Marker);
